import { font } from '@approvalmax/ui';
import styled from 'styled-components';

export const Root = styled.div`
    margin-top: 5px;
    ${font(13, '#7f7d7d')}
`;
